export default __webpack_public_path__ + "static/media/bSmart.0053e312.svg";